export default __webpack_public_path__ + "static/media/grade-st-360.e3317bdb.png";